export default {
  state: {
    sliders: {
      media: {
        slides: [
          {
            href:
              "https://b-pointer.ru/v-rossii-zapushhena-pervaya-v-mire-cifrovaya-platforma-pryamoj-adresnoj-pomoshhi/",
            logo: "bussines_pointer.jpg"
          },
          {
            href:
              "https://nabchelni.bezformata.com/listnews/platformu-pryamoj-adresnoj-pomoshi/84900225/",
            logo: "logobezformata_z.jpg"
          },
          {
            href:
              "https://mediagoods.ru/tpost/kobau12fg9-prosit-pomosch-nestidno",
            logo: "logo_mediagoods_2020.png"
          },
          {
            href:
              "https://24.kz/kz/zha-aly-tar/o-am/item/419148-elimizde-ajyrymdyly-zhasaushylar-a-arnal-an-sajt-ashylady",
            logo: "logonewkhabar.png"
          },
          {
            href:
              "https://www.kazpravda.kz/fresh/view/obedinenie-s-tselu-pomoshchi",
            logo: "logonew.png"
          },
          {
            href:
              "https://rezonans.kz/v-kazakhstane-zapushen-perviy-onlain-service-vzaimipomoshi/",
            logo: "rezonans.png"
          },
          {
            href: "https://www.oprf.ru/press/news/2617/newsitem/53739",
            logo: "3-nYotDp1VDMyHC1jQ6AQa.png"
          },
          {
            href:
              "https://kapital.kz/business/87141/kak-poluchit-obrazovaniye-i-sotspomoshch-onlayn.html",
            logo: "3dd2cE-4kJbJ9-79ZjO6ox.svg"
          },
          {
            href: "https://digital.tatarstan.ru/index.htm/news/1769991.htm",
            logo: "2g-IAwszlz0R5K7eHIFTZY.svg"
          },
          {
            href:
              "https://bluescreen.kz/community/onlajn-kz-pomoshh-v-pare-klikov-ot-vas/",
            logo: "1nKN014l4b8s79RLsrPqL7.svg"
          },
          {
            href:
              "https://news.rambler.ru/other/44349113-v-rossii-zapuschena-pervaya-v-mire-tsifrovaya-platforma-pryamoy-adresnoy-pomoschi/",
            logo: "31-vgBfUeHOdkR8HXt5HP6.png"
          },
          {
            href:
              "https://dknews.kz/inner-news.php?id_cat=17%20&&%20id=80001&fbclid=IwAR1WFL9jhULBn-CSUYmU8bRD5qPWUnvvgrD_qVtZW8f9Ea8n_y7rFsE5ojc",
            logo: "2Ne-jT4Hrq0YHpqbbczTWW.png"
          },

          {
            href:
              "https://itpark.tech/news/rezident-biznes-inkubatora-sozdal-tsifrovuyu-platformu-pryamoy-adresnoy-pomoshchi/?city=chelny",
            logo: "3UuE4Zui8rA_GlKBtit9KM.png"
          },
          {
            href:
              "https://www.inalmaty.kz/news/2765158/almatinskij-biznesmen-razrabotal-sajt-dla-razmesenia-zaavok-na-polucenie-socpomosi",
            logo: "nK3LHvN3oAolx2f6joZ0m.png"
          },
          {
            href: "https://pfo.volga.news/article/541764.html",
            logo: "33kJpde_0RX8dtkAgroCpp.png"
          },
          {
            href:
              "https://v-chelny.ru/news/economy/rezident-biznes-inkubatora-sozdal-cifrovuju-platformu-pryamoj-adresnoj-pomoshhi/",
            logo: "3oWlJ8M85DdOP-2jjDfObl.png"
          },
          {
            href:
              "https://kazan.bezformata.com/listnews/vzaimopomoshi-dlya-volonterov-i-nuzhdayushihsya/84902508/",
            logo: "logobezformata_z.jpg"
          }
        ]
      },
      partners: {
        slides: [
          {
            href: "https://sailet.pro",
            logo: "12AzhkUkBYZ-p4x8Ku1aPi.svg",
            banner: "f4f61c9f-735b-4fce-94e5-3b410f330694.png"
          },
          {
            href: "https://connect-ed.kz",
            logo: "1b75f77a-edb6-4983-a606-09d47f2dcf51.jpg",
            banner: "connect-ed.png"
          }
        ]
      }
    }
  },
  getters: {
    slidesMedia: state => state.sliders.media.slides,
    slidesPartners: state => state.sliders.partners.slides
  }
};
